<template>
  <div class="hello">
    <home-tile v-for="tiles in data" :text="tiles.text" :imgSrc="tiles.imgSrc" :key="tiles.text" :left="tiles.left" :link="tiles.link" :title="tiles.title"/>
    <!-- <trust :title="trustTitle"/> -->
  </div>
</template>

<script>
import HomeTile from "./HomeTile";
import DataJson from "../data/homeData.json";

export default {
  name: "HelloWorld",
  components: { HomeTile },
  data() {
    return {
      data: DataJson,
      trustTitle: "Ils nous ont fait confiance",
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
